import { ProductOffering } from '@travelwin/core';

export const isStockAvailable = (planDetails: ProductOffering) => {
  const { stock_available, status } = planDetails;
  return stock_available && status.id === 'ACTIVE';
};
